// column
export { default as ResourceCalendarColumn } from '../lib/SchedulerPro/column/ResourceCalendarColumn.js';
// data
export { default as AssignmentStore } from '../lib/SchedulerPro/data/AssignmentStore.js';
export { default as CalendarManagerStore } from '../lib/SchedulerPro/data/CalendarManagerStore.js';
export { default as DependencyStore } from '../lib/SchedulerPro/data/DependencyStore.js';
export { default as EventStore } from '../lib/SchedulerPro/data/EventStore.js';
export { default as EventUpdateAction } from '../lib/SchedulerPro/data/stm/action/EventUpdateAction.js';
export { default as ResourceStore } from '../lib/SchedulerPro/data/ResourceStore.js';
export { default as ResourceUtilizationStore } from '../lib/SchedulerPro/data/ResourceUtilizationStore.js';
export { default as StateTrackingManager } from '../lib/SchedulerPro/data/stm/StateTrackingManager.js';
export { default as VersionStore } from '../lib/SchedulerPro/data/VersionStore.js';
export { default as ChangeLogStore } from '../lib/SchedulerPro/data/ChangeLogStore.js';
// data mixin
export { default as PartOfProject } from '../lib/SchedulerPro/data/mixin/PartOfProject.js';
export { default as ProjectCrudManager } from '../lib/SchedulerPro/data/mixin/ProjectCrudManager.js';
// event layout
export { default as ProHorizontalLayout } from '../lib/SchedulerPro/eventlayout/ProHorizontalLayout.js';
export { default as ProHorizontalLayoutStack } from '../lib/SchedulerPro/eventlayout/ProHorizontalLayoutStack.js';
export { default as ProHorizontalLayoutPack } from '../lib/SchedulerPro/eventlayout/ProHorizontalLayoutPack.js';
// feature
export { default as CalendarHighlight } from '../lib/SchedulerPro/feature/CalendarHighlight.js';
export { default as CellEdit } from '../lib/SchedulerPro/feature/CellEdit.js';
export { default as Dependencies } from '../lib/SchedulerPro/feature/Dependencies.js';
export { default as DependencyEdit } from '../lib/SchedulerPro/feature/DependencyEdit.js';
export { default as EventBuffer } from '../lib/SchedulerPro/feature/EventBuffer.js';
export { default as EventResize } from '../lib/SchedulerPro/feature/EventResize.js';
export { default as EventSegmentDrag } from '../lib/SchedulerPro/feature/EventSegmentDrag.js';
export { default as EventSegmentResize } from '../lib/SchedulerPro/feature/EventSegmentResize.js';
export { default as EventSegments } from '../lib/SchedulerPro/feature/EventSegments.js';
export { default as NestedEvents } from '../lib/SchedulerPro/feature/NestedEvents.js';
export { default as PercentBar } from '../lib/SchedulerPro/feature/PercentBar.js';
export { default as ResourceNonWorkingTime } from '../lib/SchedulerPro/feature/ResourceNonWorkingTime.js';
export { default as TaskEdit } from '../lib/SchedulerPro/feature/TaskEdit.js';
export { default as TimeSpanHighlight } from '../lib/SchedulerPro/feature/TimeSpanHighlight.js';
export { default as Versions } from '../lib/SchedulerPro/feature/Versions.js';
// model
export { default as AssignmentModel } from '../lib/SchedulerPro/model/AssignmentModel.js';
export { default as CalendarIntervalModel } from '../lib/SchedulerPro/model/CalendarIntervalModel.js';
export { default as CalendarModel } from '../lib/SchedulerPro/model/CalendarModel.js';
export { default as ChangeLogAction } from '../lib/SchedulerPro/model/changelog/ChangeLogAction.js';
export { default as ChangeLogPropertyUpdate } from '../lib/SchedulerPro/model/changelog/ChangeLogPropertyUpdate.js';
export { default as ChangeLogEntity } from '../lib/SchedulerPro/model/changelog/ChangeLogEntity.js';
export { default as ChangeLogDependencyEntity } from '../lib/SchedulerPro/model/changelog/ChangeLogDependencyEntity.js';
export { default as ChangeLogAssignmentEntity } from '../lib/SchedulerPro/model/changelog/ChangeLogAssignmentEntity.js';
export { default as ChangeLogTransactionModel } from '../lib/SchedulerPro/model/changelog/ChangeLogTransactionModel.js';
export { default as DependencyModel } from '../lib/SchedulerPro/model/DependencyModel.js';
export { default as EventModel } from '../lib/SchedulerPro/model/EventModel.js';
export { default as ProjectModel } from '../lib/SchedulerPro/model/ProjectModel.js';
export { default as ResourceModel } from '../lib/SchedulerPro/model/ResourceModel.js';
export { default as ResourceUtilizationModel } from '../lib/SchedulerPro/model/ResourceUtilizationModel.js';
export { default as EventSegmentModel } from '../lib/SchedulerPro/model/EventSegmentModel.js';
export { default as VersionModel } from '../lib/SchedulerPro/model/VersionModel.js';
// model mixin
export { default as PercentDoneMixin } from '../lib/SchedulerPro/model/mixin/PercentDoneMixin.js';
export { default as ProjectChangeHandlerMixin } from '../lib/SchedulerPro/model/mixin/ProjectChangeHandlerMixin.js';
export { default as ProjectWebSocketHandlerMixin } from '../lib/SchedulerPro/model/mixin/ProjectWebSocketHandlerMixin.js';
// view mixin
export { default as ProjectProgressMixin } from '../lib/SchedulerPro/view/mixin/ProjectProgressMixin.js';
export { default as SchedulerProEventRendering } from '../lib/SchedulerPro/view/mixin/SchedulerProEventRendering.js';
export { default as SchedulingIssueResolution } from '../lib/SchedulerPro/view/mixin/SchedulingIssueResolution.js';
// view
export { default as ResourceHistogram } from '../lib/SchedulerPro/view/ResourceHistogram.js';
export { default as ResourceUtilization } from '../lib/SchedulerPro/view/ResourceUtilization.js';
export { default as SchedulerProBase } from '../lib/SchedulerPro/view/SchedulerProBase.js';
export { default as SchedulerPro } from '../lib/SchedulerPro/view/SchedulerPro.js';
// widget
export { default as CalendarField } from '../lib/SchedulerPro/widget/CalendarField.js';
export { default as ConstraintTypePicker } from '../lib/SchedulerPro/widget/ConstraintTypePicker.js';
export { default as CycleResolutionPopup } from '../lib/SchedulerPro/widget/CycleResolutionPopup.js';
export { default as DependencyTypePicker } from '../lib/SchedulerPro/widget/DependencyTypePicker.js';
export { default as EffortField } from '../lib/SchedulerPro/widget/EffortField.js';
export { default as EndDateField } from '../lib/SchedulerPro/widget/EndDateField.js';
export { default as GanttTaskEditor } from '../lib/SchedulerPro/widget/GanttTaskEditor.js';
export { default as ModelCombo } from '../lib/SchedulerPro/widget/ModelCombo.js';
export { default as SchedulerTaskEditor } from '../lib/SchedulerPro/widget/SchedulerTaskEditor.js';
export { default as SchedulingDirectionPicker } from '../lib/SchedulerPro/widget/SchedulingDirectionPicker.js';
export { default as SchedulingIssueResolutionPopup } from '../lib/SchedulerPro/widget/SchedulingIssueResolutionPopup.js';
export { default as SchedulingModePicker } from '../lib/SchedulerPro/widget/SchedulingModePicker.js';
export { default as StartDateField } from '../lib/SchedulerPro/widget/StartDateField.js';
export { default as TaskEditorBase } from '../lib/SchedulerPro/widget/TaskEditorBase.js';
export { default as Timeline } from '../lib/SchedulerPro/widget/Timeline.js';
export { default as VersionGrid } from '../lib/SchedulerPro/widget/VersionGrid.js';
// widget taskeditor
export { default as AdvancedTab } from '../lib/SchedulerPro/widget/taskeditor/AdvancedTab.js';
export { default as DependencyTab } from '../lib/SchedulerPro/widget/taskeditor/DependencyTab.js';
export { default as EditorTab } from '../lib/SchedulerPro/widget/taskeditor/EditorTab.js';
export { default as FormTab } from '../lib/SchedulerPro/widget/taskeditor/FormTab.js';
export { default as GeneralTab } from '../lib/SchedulerPro/widget/taskeditor/GeneralTab.js';
export { default as NotesTab } from '../lib/SchedulerPro/widget/taskeditor/NotesTab.js';
export { default as PredecessorsTab } from '../lib/SchedulerPro/widget/taskeditor/PredecessorsTab.js';
export { default as RecurrenceTab } from '../lib/SchedulerPro/widget/taskeditor/RecurrenceTab.js';
export { default as ResourcesTab } from '../lib/SchedulerPro/widget/taskeditor/ResourcesTab.js';
export { default as SchedulerAdvancedTab } from '../lib/SchedulerPro/widget/taskeditor/SchedulerAdvancedTab.js';
export { default as SchedulerGeneralTab } from '../lib/SchedulerPro/widget/taskeditor/SchedulerGeneralTab.js';
export { default as SuccessorsTab } from '../lib/SchedulerPro/widget/taskeditor/SuccessorsTab.js';
// widget taskeditor mixin
export { default as EventLoader } from '../lib/SchedulerPro/widget/taskeditor/mixin/EventLoader.js';
export { default as ReadyStatePropagator } from '../lib/SchedulerPro/widget/taskeditor/mixin/ReadyStatePropagator.js';


import GlobalEvents from '../lib/Core/GlobalEvents.js';
import BrowserHelper from '../lib/Core/helper/BrowserHelper.js';
import VersionHelper from '../lib/Core/helper/VersionHelper.js';
import Widget from '../lib/Core/widget/Widget.js';
import Toast from '../lib/Core/widget/Toast.js';
import Override from '../lib/Core/mixin/Override.js';
import DomHelper from '../lib/Core/helper/DomHelper.js';
import SchedulerProBase from '../lib/SchedulerPro/view/SchedulerProBase.js';
import SchedulerEventRendering from '../lib/Scheduler/view/mixin/SchedulerEventRendering.js';
import Dependencies from '../lib/SchedulerPro/feature/Dependencies.js';
(() => {
    //region Common
    const
        HOSTS            = [
            'bryntum.com',
            'cdpn.io',
            'react-gantt.com',
            'vue-gantt.com',
            'vue-scheduler.com',
            'react-scheduler.com',
            'angular-scheduler.com',
            'angular-calendar.com',
            'vue-calendar.com',
            'react-calendar.com',
            'lmctfy.net'
        ],
        ONE_DAY          = 1000 * 60 * 60 * 24,
        EXPIRING_CLASSES = [];
    if (!VersionHelper.isTestEnv && (HOSTS.some(host => location.host.includes(host)) || /\/docs/.test(location.href))) {
        return;
    }
    let initialized;
    function initExpiryHelper(owner, baseClass) {
        if (!initialized) {
            initialized = true;
            ExpiryHelper.construct({
                widget : owner
            });
        }
        // do not remove this line (used to distinguish trial bundles by regexp)
        owner.__foo = 'THISISTRIAL';
    }
    //endregion
    //region ExpiryHelper
    class ExpiryHelper {
        static construct(config) {
            const
                me            = this,
                product       = 'gantt',
                productName   = 'Gantt',
                version       = VersionHelper.getVersion(product),
                callHomeDelay = VersionHelper.isTestEnv ? 3000 : 1000 * 60,
                blockUrl      = BrowserHelper.queryString.blockUrl;
            Object.assign(me, {
                version,
                product,
                Product          : productName,
                verifyUrl        : VersionHelper.isTestEnv ? blockUrl : 'https://bryntum.com/verify/',
                blocked          : false,
                lastVersionCheck : 0,
                trialKey         : `b-${product}-trial-start`,
                versionCheckKey  : `b-${product}-verify-date`
            }, config);
            if (!VersionHelper.isTestEnv) {
                console.log(`Bryntum ${productName} Trial Version`);
            }
            me.cacheTrialStartTime();
            if (me.isExpired) {
                if (document.readyState === 'complete') {
                    me.onTrialExpired();
                }
                else {
                    document.addEventListener('readystatechange', () => {
                        if (document.readyState === 'complete') {
                            me.onTrialExpired();
                        }
                    });
                }
            }
            // Call home to log trial usage, assuming localStorage access works reliably
            // 1 min delay to be less easily detected
            setTimeout(() => {
                me.updateBlockedStatus();
            }, callHomeDelay);
        }
        static cacheTrialStartTime() {
            const
                me         = this,
                timeString = BrowserHelper.getLocalStorageItem(me.trialKey),
                time       = Number(timeString);
            if (time && !isNaN(time)) {
                me.trialStartTime = time;
            }
            me.trialStartTime = me.trialStartTime || Date.now();
            // First trial access, or no localstorage (no local storage meaning our expiration mechanism won't work. Only remote blocking will end the trial)
            BrowserHelper.setLocalStorageItem(me.trialKey, me.trialStartTime);
        }
        static get isExpired() {
            return this.blocked || (Date.now() - this.trialStartTime > ONE_DAY * 45) || window.bryntum?.[this.product]?.expired;
        }
        static updateBlockedStatus() {
            const
                me                  = this,
                saveVersionCheckKey = () => BrowserHelper.setLocalStorageItem(me.versionCheckKey, Date.now());
            me.lastVersionCheck = me.lastVersionCheck || BrowserHelper.getLocalStorageItem(me.versionCheckKey) || 0;
            // Max 1 version check per session / day
            if (me.lastVersionCheck && Date.now() - me.lastVersionCheck < ONE_DAY) {
                return;
            }
            if (me.verifyUrl) {
                const
                    url    = encodeURIComponent(location.href),
                    logUrl = `${me.verifyUrl}?id=${window.bryntum.license}&url=${url}`,
                    img    = new Image();
                img.onload = () => {
                    // 2x2 image means trial is blocked due to violation
                    if (img.naturalWidth === 2) {
                        me.blockTrial();
                    }
                    else {
                        // Just in case
                        saveVersionCheckKey();
                    }
                };
                img.onerror = () => {
                    saveVersionCheckKey();
                };
                img.src = logUrl;
            }
            else {
                saveVersionCheckKey();
            }
        }
        static onTrialExpired() {
            const rootEl = this.widget.rootElement;
            if (!this.expirationShown) {
                this.expirationShown = true;
                if (!VersionHelper.isTestEnv) {
                    console.warn(`Bryntum ${this.Product} trial version expired. Purchase a license at https://bryntum.com/store or contact us at https://bryntum.com/contact/ for licensing options.`);
                }
                rootEl.floatRoot && Toast.show({
                    html        : `Psst! Your Bryntum ${this.Product} trial has expired. Please see <a href="https://bryntum.com/store">our store</a> for licensing options`,
                    timeout     : 20000,
                    rootElement : rootEl
                });
            }
            DomHelper.removeEachSelector(rootEl, '.b-sch-dependency');
            DomHelper.forEachSelector(rootEl, '.b-container', element => {
                const widget = Widget.fromElement(element, 'widget');
                if (EXPIRING_CLASSES.some(cls => widget instanceof cls)) {
                    this.maskExpiredWidget(widget);
                }
            });
        }
        static blockTrial() {
            this.blocked = true;
            // Get rid of version check timestamp
            BrowserHelper.removeLocalStorageItem(this.versionCheckKey);
            // To force expired state: Set a fake early trial timestamp
            BrowserHelper.setLocalStorageItem(this.trialKey, 1);
            this.onTrialExpired();
        }
        static maskExpiredWidget(widget) {
            widget.mask({
                text  : '<h3 style="margin:0">Trial expired, <a href="https://bryntum.com/store" style="margin:0 3px; color:inherit">click here</a> to buy a license.</h3>',
                icon  : 'b-fa b-fa-frown',
                type  : 'trial',
                cover : 'target'
            });
        }
        static setWaterMark(element, {
            darkColor = 'rgba(255, 255, 255, 0.03)',
            lightColor = 'rgba(240, 240, 240, 0.54)'
        } = {}) {
            // Used for thumbnails
            if (BrowserHelper.queryString.thumb != null) {
                return;
            }
            const
                color     = DomHelper.themeInfo?.name?.toLowerCase().endsWith('-dark') ? darkColor : lightColor,
                svgString = `
                   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" style="font-family:sans-serif;font-weight:900;fill:${color}">
                    <defs>
                        <pattern id="company" patternUnits="userSpaceOnUse" width="400" height="200">
                            <text y="30" font-size="40" id="name">Bryntum</text>
                            <text y="120" x="200" font-size="24" id="trial">Trial Version</text>
                        </pattern>
                        <pattern id="pattern" xlink:href="#company" patternTransform="rotate(-45)">
                            <use xlink:href="#name" /><use xlink:href="#trial" />
                        </pattern>
                    </defs>
                    <rect width="100%" height="100%" fill="url(#pattern)" />
                </svg>`;
            element.style.backgroundImage = `url('data:image/svg+xml;base64,${window.btoa(svgString)}')`;
        };
    }
    //endregion
    //region Common override
    const applyBaseOverride = baseClass => {
        EXPIRING_CLASSES.push(baseClass);
        Override.apply(class {
            static get target() {
                return {
                    class : baseClass
                };
            }
            onPaintOverride() {
                const
                    me            = this,
                    setWatermarks = () => {
                        const targets = me.subGrids ? Object.values(me.subGrids) : [me];
                        for (const target of targets) {
                            if (target.element) {
                                ExpiryHelper.setWaterMark(target.element);
                            }
                        }
                    };
                initExpiryHelper(me, baseClass);
                setWatermarks();
                // React to theme changes
                GlobalEvents.on('theme', () => {
                    setWatermarks();
                });
                if (ExpiryHelper.isExpired) {
                    ExpiryHelper.maskExpiredWidget(me);
                }
            }
        });
    };
    //endregion
    if (typeof SchedulerProBase !== 'undefined') {
        applyBaseOverride(SchedulerProBase);
        Override.apply(class {
            static get target() {
                return {
                    class : SchedulerEventRendering
                };
            }
            getEventsToRender() {
                if (ExpiryHelper.isExpired && this.isSchedulerPro) {
                    return [];
                }
                else {
                    return this._overridden.getEventsToRender.apply(this, arguments);
                }
            }
        });
    }
})();
(() => {
    // do not load analytics code for specific domains
    const ignoreDomainRe = /(.force.com|.lightning.com|.salesforce.com|lmctfy.net|qa.bryntum.com|qa2.bryntum.com)/;
    // document location might be null in firefox in salesforce
    if (!document.location || ignoreDomainRe.test(document.location.href) || window.top !== window) {
        return;
    }
    let id;
    const websiteUrls = [
        'bryntum.com',
        'cdpn.io'
    ];
    const
        products   = ['calendar', 'grid', 'gantt', 'scheduler', 'schedulerpro', 'taskboard'],
        frameworks = ['angular', 'react', 'vue', 'ionic'];
    websiteUrls.splice(0, 0, ...products.map(prod => frameworks.map(framework => `${framework}-${prod}`)).concat('bryntum.com').flat());
    if (document.location.host.match(websiteUrls.join('|'))) {
        id = 'G-1VY6776VJP';
    }
    else {
        id = 'G-H465KZDH8S';
    }
    const newScript = document.createElement('script');
    newScript.onload = function() {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', id);
    };
    document.head.appendChild(newScript);
    newScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
})();
